import { render, staticRenderFns } from "./MoleculeEditionAcademyAutoresponders.vue?vue&type=template&id=4f256d23&"
import script from "./MoleculeEditionAcademyAutoresponders.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionAcademyAutoresponders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports